import service from '@/base/service'
import qs from 'qs'

const baseURL = process.env.VUE_APP_BASE_API_AI

const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}

const requestT = (data) =>{
   return service({
     ...data,
     baseURL:process.env.VUE_APP_BASE_API_TYUN
   })
}
// 清洗号码列表
// export function cleaningNumberList (data) {
//     return request({
//       url: '/clearTask/list',
//       method: 'get',
//       params: data
//     })
//   }
export function cleaningNumberList (data) {
  return request({
    url: '/clearTask/pageList',
    method: 'post',
    data
  })
}

// 清洗号码类型数量
export function cleaningNumberNum (data) {
    return request({
      url: '/clearTask/total',
      method: 'get',
      params: data
    })
  }

// 清洗任务明细
export function cleaningNumberInfo (data) {
  return request({
    url: '/clearTask/info',
    method: 'get',
    params: data
  })
}

// 任务名称校验
export function checkTaskName (data) {
  return request({
    url: '/clearTask/check',
    method: 'post',
    data
  })
}

// 默认清洗手机号条数
export function defaultCleaningTotal (data) {
  return request({
    url: '/vv6/clue/total',
    method: 'get',
    params: data
  })
}

// 手机号清洗剩余额度
export function cleaningSusplus () {
  return request({
    url: '/home/susplus',
    method: 'get'
  })
}

// 创建清洗任务
export function creatCleaningTask(data){
  return request({
    url:'/clearTask/add',
    method:'POST',
    data
  })
}

// tyun(控制台)子账号管理
export function listEmployee(data){
  return requestT({
    url:'/employee/listEmployee',
    method:'POST',
    params: data
  })
}